import { render, staticRenderFns } from "./course-dialog.vue?vue&type=template&id=738bdb0f&scoped=true&"
import script from "./course-dialog.vue?vue&type=script&lang=js&"
export * from "./course-dialog.vue?vue&type=script&lang=js&"
import style0 from "./course-dialog.vue?vue&type=style&index=0&id=738bdb0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738bdb0f",
  null
  
)

export default component.exports